import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/auth/authContext";

const ContributorRoute = ({ component: Component }) => {
  const authContext = useContext(AuthContext);
  const { isAuthenticated, loading, user } = authContext;

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  if (!user) {
    return <Navigate to="/admin-login" replace />;
  }

  if (
    user.userStatus !== "Contributor" &&
    user.userStatus !== "Admin" &&
    user.userStatus !== "Super Admin"
  ) {
    return <Navigate to="/admin-login" replace />;
  }

  return <Component />;
};

export default ContributorRoute;
